import _slicedToArray from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.pad-end.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { cloneDeep } from 'lodash';
import util from '@/libs/util';
import Unique from '@/plugins/auth/unique';
import Setting from '@/setting';
import Token from '@/plugins/auth/token';
var Tool = {
  /**
   * 深度克隆
   * @param obj
   * @returns {null|*}
   */
  clone: function clone(obj) {
    if (!obj) {
      return null;
    }
    return cloneDeep(obj);
  },
  /**
   * 比较对象内容
   * @param original 原始对象
   * @param target 目标对象
   * @returns {boolean}
   */
  compare: function compare(original, target) {
    return JSON.stringify(original) === JSON.stringify(target);
  },
  /**
   * 判断对象是否为空
   * @param val
   * @returns {boolean}
   */
  isNull: function isNull(val) {
    if (typeof val === 'number' && !isNaN(val) && val === 0) {
      return false;
    }
    return val == null || val == undefined || val == '' || val == 'null' || val == 'undefined' || val.length == 0;
  },
  /**
   * 判断对象是否非空
   * @param val
   * @returns {boolean}
   */
  isNotNull: function isNotNull(val) {
    return !Tool.isNull(val);
  },
  /**
   * 获取上传header
   * @returns {Promise<{'user-sid'}>}
   */
  getUploadHeader: function getUploadHeader() {
    var token = util.cookies.get('token');
    return {
      'user-sid': token
    };
  },
  /**
   * 转换为文件大小
   * @param size
   * @param pointLength
   * @param units
   * @returns {string}
   */
  formatSize: function formatSize(size, pointLength, units) {
    var unit;
    units = units || ['B', 'K', 'M', 'G'];
    while ((unit = units.shift()) && size > 1024) {
      size = size / 1024;
    }
    return (unit === 'B' ? size : size.toFixed(pointLength === undefined ? 2 : pointLength)) + unit;
  },
  /**
   * 去掉html元素
   * @param val
   * @returns {*}
   */
  getText: function getText(val) {
    if (Tool.isNull(val)) {
      return val;
    }
    return val.replace(/<\/?.+?>/g, '').replace(/ /g, '').replace(/&\/?.+?;/g, '');
  },
  getHtmlFamily: function getHtmlFamily(html) {
    var div = document.createElement('div');
    div.innerHTML = html;
    var children = div.children;
    if (Tool.isNull(children)) {
      var p = document.createElement('div');
      p.innerText = html;
      div.innerHTML = p.outerHTML;
      children = div.children;
    }
    var family = [];
    for (var j = 0; j < children.length; j++) {
      var node = children[j];
      var styles = {};
      for (var i = 0; i < node.style.length; i++) {
        var styleName = node.style.item(i);
        styles[styleName] = node.style.getPropertyValue(styleName);
      }
      family.push({
        nodeName: node.nodeName,
        text: node.innerText,
        style: styles
      });
    }
    return family;
  },
  getPercent: function getPercent(num, total) {
    num = parseFloat(num);
    total = parseFloat(total);
    if (isNaN(num) || isNaN(total)) {
      return '-';
    }
    return total <= 0 ? 0 : Math.round(num / total * 10000) / 100;
  },
  formatPrice: function formatPrice(price) {
    return price.toString().replace(/\d+/, function (m) {
      return m.replace(/(?=(\B)(\d{3})+$)/g, ',');
    });
  },
  getHeader: function getHeader() {
    var add = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var header = {};
    var uniqueId = Unique.get();
    header[Setting.request.header.uniqueIdName] = uniqueId;
    var token = Token.get();
    if (token) {
      header[Setting.request.header.tokenName] = Setting.request.header.tokenNamePrefix + token;
    }
    return _objectSpread(_objectSpread({}, header), add);
  },
  /**
   * 解决下拉框多选回显问题
   * @param {*} total
   * @returns
   */
  powArr: function powArr() {
    var total = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var _pow = 0;
    var _sum = 0;
    var _powArr = [];
    //求出只选一个，最大的_pow是多少，然后小于_pow的都有可能被选到
    while (_sum < total) {
      _sum = Math.pow(2, _pow);
      if (_sum <= total) {
        _powArr.push(Math.pow(2, _pow));
      }
      _pow++;
    }
    //求出可能被选的，有多少个组合
    var _combinations = [];
    function recursion(sIndex, combArr) {
      for (var m = sIndex; m < _powArr.length; m++) {
        var _ar = _toConsumableArray(combArr);
        _ar.push(_powArr[m]);
        _combinations.push(_ar);
        recursion(m + 1, _ar);
      }
    }
    recursion(0, []);
    //求出哪个组合和是这个值
    var _index = -1;
    var _loop = function _loop() {
      var _sum = 0;
      _combinations[n].forEach(function (val) {
        _sum += val;
      });
      if (_sum === total) {
        _index = n;
        return 1; // break
      }
    };
    for (var n = 0; n < _combinations.length; n++) {
      if (_loop()) break;
    }
    return _index == -1 ? [] : _combinations[_index];
  },
  /**
   * @description 绑定事件 on(element, event, handler)
   */
  on: function on() {
    {
      if (document.addEventListener) {
        return function (element, event, handler) {
          if (element && event && handler) {
            element.addEventListener(event, handler, false);
          }
        };
      } else {
        return function (element, event, handler) {
          if (element && event && handler) {
            element.attachEvent('on' + event, handler);
          }
        };
      }
    }
  },
  /**
   * @description 解绑事件 off(element, event, handler)
   */
  off: function off() {
    if (document.removeEventListener) {
      return function (element, event, handler) {
        if (element && event) {
          element.removeEventListener(event, handler, false);
        }
      };
    } else {
      return function (element, event, handler) {
        if (element && event) {
          element.detachEvent('on' + event, handler);
        }
      };
    }
  },
  /**
   * 根据 \n或者, 分割成数组
   * @param input
   * @returns {string[]|*[]}
   */
  toList: function toList(input) {
    if (input == null) return [];
    return String(input).split(/[\n,]+/) // 兼容 a\nb\nc 或 a,b,c（也支持混合）
    .map(function (s) {
      return s.trim();
    }) // 去两端空格
    .filter(Boolean); // 去掉空项
  },
  toCNY: function toCNY(input) {
    if (input === null || input === undefined || input === '') return '';
    var n = Number(input);
    if (!isFinite(n)) return '';
    var negative = n < 0;
    n = Math.abs(n);

    // 四舍五入到分，避免浮点误差
    n = Math.round(n * 100) / 100;
    var CN_NUM = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
    var CN_INT_RADICE = ['', '拾', '佰', '仟'];
    var CN_INT_UNITS = ['', '万', '亿', '兆'];
    var CN_DEC_UNITS = ['角', '分'];
    var CN_INT_LAST = '元';
    var CN_INTEGER = '整';
    var _n$toFixed$split = n.toFixed(2).split('.'),
      _n$toFixed$split2 = _slicedToArray(_n$toFixed$split, 2),
      intStrRaw = _n$toFixed$split2[0],
      _n$toFixed$split2$ = _n$toFixed$split2[1],
      decStrRaw = _n$toFixed$split2$ === void 0 ? '' : _n$toFixed$split2$;
    var intStr = intStrRaw === '0' ? '0' : intStrRaw.replace(/^0+/, '');
    var decStr = decStrRaw.padEnd(2, '0').slice(0, 2);
    var result = '';

    // 整数部分（为 0 时先不输出“零元”，避免 0.01 => 零元零壹分）
    if (intStr !== '0') {
      var intPart = '';
      var zeroCount = 0;
      var len = intStr.length;
      for (var i = 0; i < len; i++) {
        var p = len - i - 1;
        var d = Number(intStr.charAt(i));
        var quotient = Math.floor(p / 4);
        var modulus = p % 4;
        if (d === 0) {
          zeroCount++;
        } else {
          if (zeroCount > 0) intPart += CN_NUM[0];
          zeroCount = 0;
          intPart += CN_NUM[d] + CN_INT_RADICE[modulus];
        }
        if (modulus === 0) {
          var groupStart = i - (3 - modulus); // i-3
          var group = intStr.substr(groupStart, 4);
          if (!/^0{4}$/.test(group)) intPart += CN_INT_UNITS[quotient];
        }
      }
      intPart = intPart.replace(/零+/g, '零').replace(/零(万|亿|兆)/g, '$1').replace(/亿万/g, '亿').replace(/零$/g, '');
      result = intPart + CN_INT_LAST;
    }

    // 小数部分
    var jiao = Number(decStr.charAt(0));
    var fen = Number(decStr.charAt(1));
    if (jiao === 0 && fen === 0) {
      // 0.00 -> 零元整；12.00 -> 壹拾贰元整
      if (!result) result = CN_NUM[0] + CN_INT_LAST;
      result += CN_INTEGER;
    } else {
      if (jiao > 0) result += CN_NUM[jiao] + CN_DEC_UNITS[0];

      // “零X分” 只在前面已有“元/角”时需要；0.01 直接“壹分”
      if (jiao === 0 && fen > 0 && result) result += CN_NUM[0];
      if (fen > 0) result += CN_NUM[fen] + CN_DEC_UNITS[1];
    }
    return (negative ? '负' : '') + result;
  }
};
export default Tool;